import $ from 'jquery';

export default {
  bind(el, binding) {
    let $el = $(el);
    $el = $el.is('input') ? $el : $el.find('input');

    binding.def.calculate($el);

    $el.change(() => binding.def.calculate($el));
    $el.on('input', () => binding.def.calculate($el));
  },

  calculate($el) {
    let val = $el.val() || '';

    if (val != '') $el.addClass('is-dirty');
    else $el.removeClass('is-dirty');
  }
};
